import React from "react";

export default function JakOTheShadows() {
  return (
    <>
      <p class="c2">
        <span>
          <p> We’ll drink the wine till the cup is dry,</p>
          <p>And kiss the girls so they’ll not cry, </p>
          <p>And toss the dice until we fly, </p>
          <p>To dance with Jak o' the Shadows.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p> We drink all night and dance all day, </p>
          <p> And on the girls we spend our pay, </p>
          <p> And when it’s gone, then we’ll away, </p>
          <p> To dance with Jak o' the Shadows. </p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p> We’ll dance all night until the moon runs free, </p>
          <p> And dandle the lasses upon our knee, </p>
          <p> And then you’ll ride along with me, </p>
          <p> To dance with Jak o' the Shadows. </p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p> We drink all night and dance all day, </p>
          <p> And on the girls we spend our pay, </p>
          <p> And when it’s gone, then we’ll away, </p>
          <p> To dance with Jak o' the Shadows. </p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p> We’ll toss the dice however they fall, </p>
          <p> And snuggle the girls be they short or tall, </p>
          <p> Then follow Lord Mat whenever he calls, </p>
          <p> To dance with Jak o' the Shadows. </p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p> There’s some delight in ale and wine, </p>
          <p> And some in girls with ankles fine, </p>
          <p> But my delight, yes, always mine, </p>
          <p> Is to dance with Jak o' the Shadows. </p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p> We drink all night and dance all day, </p>
          <p> And on the girls we spend our pay, </p>
          <p> And when it’s gone, then we’ll away, </p>
          <p> To dance with Jak o' the Shadows. </p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p> We’ll give a yell with a bloody curse, </p>
          <p> And hug the maids, it could be worse, </p>
          <p> As we ride away with the Dark One’s purse, </p>
          <p> To dance with Jak o' the Shadows! </p>
        </span>
      </p>
    </>
  );
}
